<article
  class="ui-stepper-sub-step"
  [class.ui-stepper-sub-step--optional]="isOptional"
  [class.ui-stepper-sub-step--active]="state === 'active'"
>
  <span
    *ngIf="showConnector"
    class="ui-stepper-sub-step__connector"
    aria-hidden="true"
  ></span>
  <span
    class="ui-stepper-sub-step__status"
    [class]="'is-' + state"
    aria-hidden="true"
  >
    <span class="ui-stepper-sub-step__status-inner" [class]="'is-' + state">
      <app-stepper-icon
        *ngIf="state === 'completed'"
        class="ui-stepper-sub-step__status-icon"
        name="check"
      />
      <app-stepper-icon
        *ngIf="state === 'error'"
        class="ui-stepper-sub-step__status-icon"
        name="close"
      />
      <span
        *ngIf="state === 'active'"
        class="ui-stepper-sub-step__status-dot"
      ></span>
      <span
        *ngIf="state === 'pending'"
        class="ui-stepper-sub-step__status-dot is-pending"
      ></span>
    </span>
  </span>

  <div class="ui-stepper-sub-step__content">
    <p class="ui-stepper-sub-step__label">
      {{ subStep.label }}
    </p>
    <p
      class="ui-stepper-sub-step__caption"
      *ngIf="subStep.caption && state !== 'active'"
    >
      {{ subStep.caption }}
    </p>
  </div>

  <div class="ui-stepper-sub-step__action" *ngIf="showAction">
    <ng-container *ngIf="hasCustomAction; else legacyActionButton">
      <ng-container
        *ngComponentOutlet="customActionComponent; inputs: customActionInputs"
      />
    </ng-container>
    <ng-template #legacyActionButton>
      <button
        class="ui-stepper-sub-step__action-button"
        type="button"
        [class.icon-only]="!subStep.action?.label"
        [class.is-disabled]="subStep.action?.disabled"
        [style.color]="actionColor"
        [disabled]="subStep.action?.disabled"
        [ngbTooltip]="actionTooltip"
        [attr.aria-label]="actionAriaLabel"
        (click)="handleActionClick()"
      >
        <span
          class="ui-stepper-sub-step__action-label"
          *ngIf="subStep.action?.label"
        >
          {{ subStep.action?.label }}
        </span>
        <ng-container
          *ngComponentOutlet="
            subStep.action?.icon;
            inputs: { height: '16px', width: '16px' }
          "
        />
      </button>
    </ng-template>
  </div>
</article>
